module.exports = __webpack_public_path__ + "img/app.0c817720.svg";